/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_SubmitInputs */

const en_directory_footer_link_submit = /** @type {(inputs: Directory_Footer_Link_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a tool`)
};

const zh_directory_footer_link_submit = /** @type {(inputs: Directory_Footer_Link_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工具`)
};

/**
* | output |
* | --- |
* | "Submit a tool" |
*
* @param {Directory_Footer_Link_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_submit = /** @type {((inputs?: Directory_Footer_Link_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_submit(inputs)
	return zh_directory_footer_link_submit(inputs)
});
export { directory_footer_link_submit as "directory.footer.link_submit" }